export const USER_ROLES = {
  Client: 1,
  Sales: 2,
  CustomerSuccess: 3,
  Warehouse: 4,
  Picker: 5,
  Packager: 6,
  Labeler: 7,
  Manager: 8,
  Admin: 9,
  ClientAdmin: 10,
  ClientCompanyOrderAccess: 11,
  ClientCompanyInventoryOrderAccess: 12,
  DemoUser: 14,
  PackingTest: 15,
  ReceivingTest: 16,
  LabelingTest: 17,
  PickerTest: 18,
  WarehouseAssociateTest: 19,
  ClientManufacturer: 20,
  ClientCompanyBillingRestriction: 21
}

export default {
  data () {
    return {
      sideNavType: 'Merchant',
      offset: 0
    }
  },
  mounted () {
    this.$shipBobStore.dispatch('detectBrowser')
  },
  computed: {
    showSplashScreen () {
      return this.$shipBobStore.getters.showSplashScreen
    },
    adminMargin () {
      const marginTop = `${this.offset}px`
      return { marginTop }
    },
    user () {
      return this.$shipBobStore.getters['user/getUser']
    },
    isAdmin () {
      return this.user.isAdmin
    },
    isMerchantAdmin () {
      return this.user?.impersonatedRoleId === USER_ROLES.Client || this.user?.impersonatedRoleId === USER_ROLES.ClientAdmin
    }
  }
}
